'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMicB = function IoMicB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 2.5c2.7 0 5 1.8 5.9 4.6 0.5 1.4 0.3 3.5 0.1 4.3s-0.6 1.6-1.1 2.2c-0.2 0.3-0.5 0.5-0.8 0.7-0.1 0-0.1 0.1-0.2 0.1-0.2 0.1-0.4 0.1-0.7 0.2-1 0.2-2 0.4-3.1 0.4h-0.1c-1.1 0-2.3-0.2-3.3-0.4-0.3-0.1-0.5-0.1-0.7-0.2-0.1 0-0.1-0.1-0.2-0.1-0.3-0.2-0.6-0.4-0.8-0.7-0.5-0.6-1-1.4-1.1-2.2s-0.4-2.9 0.1-4.3c0.9-2.8 3.2-4.6 6-4.6z m3 13.2c0.5 0 0.9 0.4 0.9 0.9v0.2c-0.4 5.2-1.4 18.8-1.4 19.7 0 0-0.3 1-2.5 1-2.3 0-2.5-1-2.5-1-0.1-0.9-1.1-14.5-1.5-19.7v-0.2c0-0.5 0.4-0.9 0.9-0.9h0.1c0.1 0 0.1 0.1 0.1 0.1 0.2 0 0.4 0.1 0.5 0.1 0.7 0.1 1.6 0.1 2.4 0.1s1.6 0 2.3-0.1c0.2 0 0.3-0.1 0.5-0.1 0 0 0-0.1 0.1-0.1h0.1z m-2.3 6.3v-2.5c0-0.5-0.3-0.9-0.7-0.9s-0.8 0.4-0.8 0.9v2.5c0 0.5 0.3 0.9 0.8 0.9s0.7-0.4 0.7-0.9z' })
        )
    );
};

exports.default = IoMicB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/mic-b.js
// module id = 2381
// module chunks = 0